import React from "react";
import { MdArrowBackIos, MdPerson } from "react-icons/md";

import { PreviewCloudinaryImage } from "@/features/previews/shared/components";

import type { SmsHeaderProps } from "../types";

export const SmsHeader = ({ displayName, profileImage, isInitPreview }: SmsHeaderProps) => {
  return (
    <header className="sms-preview__header">
      <div className="sms-preview__back">
        <MdArrowBackIos />
      </div>

      <div className="sms-preview__profile">
        <div className="sms-preview__avatar">
          {profileImage ? (
            <PreviewCloudinaryImage
              src={profileImage}
              alt="SMS contact avatar"
              isInitPreview={isInitPreview}
              className="sms-preview__avatar-image"
              placeholderClass="sms-preview__avatar-image"
            />
          ) : (
            <span
              className="sms-preview__avatar-fallback"
              role="img"
              aria-label="Default contact avatar"
            >
              <MdPerson />
            </span>
          )}
        </div>
        <div className="sms-preview__contact-name">{displayName}</div>
      </div>
    </header>
  );
};
